import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "dialogue-modal-mask" }
const _hoisted_2 = { class: "dialogue-modal-wrapper" }
const _hoisted_3 = { class: "dialogue-modal-container" }
const _hoisted_4 = { class: "dialog-overlay" }
const _hoisted_5 = { class: "dialog" }
const _hoisted_6 = { class: "dialogue-modal-header" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "dialog-msg" }
const _hoisted_9 = { class: "footer" }
const _hoisted_10 = { class: "footer-btns" }

import { ref } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'DialogueModal',
  props: [
  "hideTitle",
  "title",
  "msg",
  "confirmButtonText",
  "cancelButtonText",
],
  emits: [
  "confirm",
  "cancel",
  "close",
],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const modalOpen = ref<boolean>(false);

function confirmAction() {
  emit("confirm");
}

function cancelAction() {
  modalOpen.value = false;
  emit("cancel");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("header", _hoisted_6, [
              (!__props.hideTitle)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_7, _toDisplayString(__props.title), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", null, _toDisplayString(__props.msg), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "btn button button-danger doAction",
                  onClick: _withModifiers(confirmAction, ["prevent"])
                }, _toDisplayString(__props.confirmButtonText), 1),
                _createElementVNode("button", {
                  class: "btn button button-default cancelAction",
                  onClick: _withModifiers(cancelAction, ["prevent"])
                }, _toDisplayString(__props.cancelButtonText), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})